<template>
  <!--
    D : 판매종료시 추가해주세요.
    tr태그에 class="is-soldout" 추가
    class="c-product-card"에 is-card-soldout 클래스 추가
    class="c-counter"에 is-soldout 클래스 추가 후 각 form에는 disabled 추가
  -->
  <tr>
    <td>
      <!-- D : 판매종료시 is-card-soldout 추가 -->
      <div class="c-product-card type-horizontal type-checkbox">
        <div class="c-checkbox type-small">
          <input
            type="checkbox"
            :id="'chk' + index"
            name="chkgroup1"
            :checked="checkedValue"
            @change="toggleItem()"
          />
          <label :for="'chk' + index">
            <span class="sr-only">상품선택</span>
          </label>
        </div>
        <div class="product-thumb">
          <div class="thumb-button">
            <div class="product-img">
              <img
                class="no-image"
                v-if="isNoPcImage"
                src="@/assets/images/common/img_no_product.svg"
                alt="No Image"
              />
              <img
                v-else
                :src="imageFilePath"
                alt=""
                @error="() => (imageErrorYn = true)"
              />
            </div>
          </div>
        </div>
        <div class="product-info">
          <div v-show="!productBadgeEmptyYn" class="c-product-badge">
            <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
              SET 제품
            </span>

            <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
              주제
            </span>
            <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
              경화제
            </span>
            <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
              경화촉진제
            </span>
            <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
              회석제
            </span>

            <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
              1액형
            </span>
            <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
              2액형
            </span>
            <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
              3액형
            </span>
          </div>
          <div class="c-product-category">
            <span class="path">{{ item.prodh1t }}</span>
            <span class="path">{{ item.prodh2t }}</span>
            <span class="path">{{ item.prodh3t }}</span>
          </div>
          <div class="product-code">{{ item.matnr }}</div>
          <strong class="product-name"
            >{{ item.zzmaktx
            }}<span style="color: red" v-if="item.qtyLack"
              >
              <!-- <br />(재고부족)가용량:{{ item.availability }}</span></strong> -->
              <br />(재고부족)</span></strong>
        </div>
        <!-- D : 판매종료 dim -->
        <div class="card-dim">
          <p class="text">담당영업사원 통한 주문품 주문건</p>
          <i class="c-icon icon-check-circle"></i>
        </div>
        <!-- // D : 판매종료 dim -->
      </div>
      <!-- // D : 판매종료시 is-card-soldout 추가 -->
    </td>
    <td class="ac">{{ item.zztotalQty }}</td>
    <td class="ac">
      <!-- <p
        class="btn-pc-pr btn-outlined"
        @click="() => (data.totalStockListPopEl = true)"
      >
        재고 확인
      </p> -->
      <div class="stock-lines" aria-label="재고 현황" v-if="data.productStocksFlag">
        <span class="stock-line" v-for="stock in data.productStocks" :key="stock.werks"> {{
            Utils.replace(
              Utils.codeNm(props.werks, stock.werks),
              "노루페인트",
              ""
            )
          }}
          :
          <strong>{{ Utils.currency(stock.labst) }}</strong>
        </span>
      </div>
    </td>
    <td class="ac">
      <div>
        <!-- D : 판매종료일때 class="c-counter" is-soldout 클래스 추가 후 각 form에는 disabled 추가해주세요. -->
        <div class="c-counter">
          <button
            type="button"
            class="btn-minus"
            :disabled="item.goodsQty <= 1"
            @click="() => item.goodsQty--"
          >
            <i class="c-icon icon-minus size-xxsmall"></i>
            <span class="sr-only">빼기</span>
          </button>
          <input
            type="number"
            title="수량입력"
            v-model="item.goodsQty"
            ref="myInput"
            @mousedown="handleMouseDown"
          />
          <button type="button" class="btn-plus" @click="() => item.goodsQty++">
            <i class="c-icon icon-plus-black size-xxsmall"></i>
            <span class="sr-only">더하기</span>
          </button>
        </div>
        <!-- // D : 판매종료일때 class="c-counter" is-soldout 클래스 추가 후 각 form에는 disabled 추가해주세요. -->
        <!-- <span class="color-danger">재고수량 : {{ item.stock }}</span> -->
      </div>
    </td>
    <td class="ar">
      {{ Number(item.kbetr * item.goodsQty).toLocaleString() }}원
    </td>
  </tr>
  <AlertWerks
    :totalStockListPopEl="data.totalStockListPopEl"
    :product="props.item"
    :werks="props.werks"
    @close="() => (data.totalStockListPopEl = false)"
    @checkStock="(productStocks) => checkProdStck(productStocks)"
  >
  </AlertWerks>
</template>

<script setup>
import {
  onMounted,
  ref,
  defineProps,
  defineEmits,
  computed,
  watch,
  inject,
  reactive,
} from "vue";
import Utils from "@/js/utils";
import { api } from "@/plugins/api";
import AlertWerks from "@/components/paintpro/common/AlertWerks.vue";

const data = reactive({
  totalStockListPopEl: false,
  productStocksFlag:false,
  productStocks:[]
});

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  index: {
    type: Number,
    require: true,
  },
  checked: {
    type: Boolean,
    require: true,
  },
  werks: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["checked", "item"]);
const myInput = ref(null);

const url = inject("url_prefix");
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref(props.item); // 제품
const imageErrorYn = ref(false);
const checkedValue = computed({
  get: () => props.checked,
  set: (value) => emit("checked", value),
});

onMounted(() => {});

watch(
  () => props.item,
  (newValue) => {
    item.value = newValue;
  }
);

// 제품 수량 입력
watch(
  () => item.value.goodsQty,
  (newQty, oldQty) => {
    if (newQty < 1) {
      item.value.goodsQty = 1;
    } else if (newQty > 99999) {
      item.value.goodsQty = oldQty;
    } else {
      item.value.goodsQty = newQty;
    }
    updateItemQuantity(item.value, item.value.goodsQty);
  }
);

// 제품 수량 변경 API
async function updateItemQuantity(updateItem, goodsQty) {
  const param = {
    orderTmpSn: updateItem.orderTmpSn,
    orderDtlTmpSn: updateItem.orderDtlTmpSn,
    goodsQty: goodsQty,
  };

  try {
    const res = await api.post(`${url}/order/updateOrderTempQty`, param);
    if (res.resultCode === 200) {
      emit("item", item.value);
    }
  } catch (e) {
    console.log("error=" + e.message);
  }
}

// 체크박스
function toggleItem() {
  checkedValue.value = !checkedValue.value;
}

const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});

const handleMouseDown = (event) => {
  event.preventDefault();
  myInput.value?.focus();
  myInput.value?.select();
};

function checkProdStck(productStocks) {
  if(productStocks.length > 0){
    data.productStocks = productStocks;
    data.productStocksFlag = true;
  }
}
</script>
